import { homeConstants } from './constants';

const INITIAL_STATE = { 
    myDebts: []
    
 };


export function home(state = INITIAL_STATE, action) {
   switch (action.type) {

     case homeConstants.STUDENT_DEBT:
 
      return {
        ...state,
        myDebts: action.myDebts 
       };
      
    default:
      return state
  }
}

